export enum TokenSymbol {
  ETH = 'ETH',
  BNB = 'BNB'
}

export enum ChainSymbol {
  ETH = 'ETH',
  BNB = 'BSC',
  BASE = 'BASE'
}
